<template lang="pug">
  .service-container
    .service-container__header.service-container__header__bg1
      .service-container__title {{ $t('媒体资源价格审计') }}
      .service-container__desc {{ $t('通过丰富海量的媒体刊例价数据、排期执行价数据、媒体返点数据、投放效果数据形成复歌专有媒体矩阵数据池。某国际奢侈品集团使用该服务进行媒介资源审计。') }}
    .service-content-container
      .service-container__subTitle
        img(src="@/assets/icon-challenge.png")
        .subTitle {{ $t('企业面临的挑战与痛点') }}

      .service-challenge-container.service-challenge-container__min
        .challenge__item
          img(
            src="@/assets/service-challenge-img.png"
          )
          i.iconfont.iconchajia
          .item__title {{ $t('价格是否买贵') }}
          .item__desc {{ $t('企业通过已有供应商或者外部寻找新供应商采购媒体资源时，缺少足够多的市场行情信息，难以真正比较供应商报价是否有竞争力，从而导致采购价格偏高或者被中间商赚取了差价。') }}
        .challenge__item
          img(
            src="@/assets/service-challenge-img.png"
          )
          i.iconfont.iconsunshi
          .item__title {{ $t('资源采购的黑盒') }}
          .item__desc {{ $t('不确定代理商推荐的供应商是否靠谱，其中是否存在着利益关系。不清楚代理商在向媒体供应商采购媒体资源时有无克扣或隐藏相关返点。媒体采买流程中的不透明性以及信息不对称，使得企业承受损失。') }}
      .service-container__subTitle
        img(src="@/assets/icon-project.png")
        .subTitle {{ $t('复歌的解决方案') }}

      .service-solution-container
        .solution-item
          .solution-content
            .solution-content__title {{ $t('价格及返点校验') }}
            .solution-content__desc {{ $t('通过复歌丰富且强大的媒介价格数据库，过滤相关地域、时间段、投放金额、广告主行业等信息核查相关媒体点位的价格、返点详情，为企业提供有效的参考价值，使其自行判断是否买贵了。')}}
            .solution-content__link(
              @click="$router.push('/product/i_media_matrix')"
            )
              img(src="@/assets/logo-matrix.png")
              span iMedia Matrix
              img.icon-entrance(src="@/assets/icon-entrance.png")
          img(
            src="@/assets/service-audit-1.png"
          )
        .solution-item
          .solution-content
            .solution-content__title {{ $t('合规性审核') }}
            .solution-content__desc {{ $t('判断整个流程是否符合法律和公司规定，帮助企业审核合同条款和KPI设定是否存在相关问题，从而帮助企业及时发现并作出调整。') }}
          img(
            src="@/assets/service-audit-2.png"
          )

        .solution-item
          .solution-content
            .solution-content__title {{ $t('资源采买回溯') }}
            .solution-content__desc {{ $t('投放完毕后帮助企业校验供应商采买资源点位是否一致、执行投放资源的实际价格是否匹配、执行周期是否符合计划、预设KPI最终是否达标等，以确保合同内承诺的信息100%完成。')}}
            .solution-content__link(
              @click="$router.push('/product/i_media_matrix')"
            )
              img(src="@/assets/logo-matrix.png")
              span iMedia Matrix
              img.icon-entrance(src="@/assets/icon-entrance.png")
          img(
            src="@/assets/service-audit-1.png"
          )
    mobile-case-sample(
      :data="caseList"
    )
    mobile-contact
</template>

<script>
import MobileContact from '@/components/MobileContact'
import MobileCaseSample from '@/components/MobileCaseSample'

export default {
  components: {
    MobileContact,
    MobileCaseSample
  },
  data () {
    return {
      caseList: [
        {
          url: '/case/price-auditing',
          img: require('@/assets/case-audit.jpg'),
          title: '某奢侈品集团',
          desc: '媒体采购时，缺少相关行业BenchMark，无法衡量资源是否买贵。'
        }
      ]
    }
  }
}
</script>
